module.exports = __webpack_public_path__ + "img/procreate-tablet_en.97a53ef.jpg";